import React, {useEffect, useRef, useState} from 'react';
import s from './ImageUpload.module.css';
import Modal from "../../../../shared/ui/modal/Modal";
import add_photo from '../../../../assets/img/add_photo_alternate.svg';
import Button from "../../../../shared/ui/button/Button";
import {generateImage, setCurrentProject, updateProject, uploadImage} from "../../../../store/slices/projectSlice";
import { useAppDispatch } from "../../../../store/store";
import { useSelector } from "react-redux";
import { selectCurrentProject } from "../../../../store/selectors/projectSelectors";
import effect from '../../../../assets/img/customize_effect.png'
import size from '../../../../assets/img/customize_size.png'
import ImageFilter from 'react-image-filter';

import CropImage from "./CropImage";
import GenerateImage from "../generate-image/GenerateImage";
import {CurrentProject} from "../../../../shared/types/projectTypes";
import FileUpload from "../../features/file-upload/FileUpload";
interface ImageUploadProps {
    imageUrl: string | null;
    currentProject:CurrentProject|null;
}

const ImageUpload: React.FC<ImageUploadProps> = ({ imageUrl,currentProject }) => {

    const [isModalOpen, setModalOpen] = useState<boolean>(false);
    const dispatch = useAppDispatch();

    const [activeFilter, setActiveFilter] = useState<string>('');
    const [editMode, setEditMode] = useState<'effect' | 'size' | ''>('');
    const [editedImage, setEditedImage] = useState<string | null>(imageUrl);
    const [croppedAreaPixels, setCroppedAreaPixels] = useState<any>(null);

    const filterOptions = [
        { name: 'Grayscale ', filter: 'grayscale' },
        { name: 'Vintage ', filter: 'vintage' },
        { name: 'Warm Glow ', filter: 'warm' },
        { name: 'Cool Tone', filter: 'cool' },
        { name: 'Retro ', filter: 'retro' },
        { name: 'Pastel Hues ', filter: 'pastel' },
        { name: 'Golden Hour ', filter: 'golden' },
        { name: 'Film Grain ', filter: 'film' },
        { name: 'Noir ', filter: 'noir' },
        { name: 'Cyberpunk ', filter: 'cyberpunk' },
        { name: 'Moody ', filter: 'moody' },
        { name: 'Sunlit', filter: 'sunlit' },
        { name: 'Oceanic ', filter: 'oceanic' },
        { name: 'Velvet ', filter: 'velvet' },
        { name: 'Vintage Blue ', filter: 'vintage-blue' },
        { name: 'Muted Sepia ', filter: 'muted-sepia' },
        { name: 'Infrared ', filter: 'infrared' },
    ];
    useEffect(() => {
        if (imageUrl) {
            setEditedImage(imageUrl);
        }
    }, [imageUrl]);

    const applyFilter=(filter:string)=>{
        setActiveFilter(filter);

    }
    const handleRetry = () => {
        setEditedImage(null);
        dispatch(updateProject( { ...currentProject, image: null } ))
    };

    const handleModalClose = () => {
        setModalOpen(false);
    };
    const handleImageUpload = async (file: File): Promise<any> => {
        const imageUrl = URL.createObjectURL(file);
        setEditedImage(imageUrl)
        return imageUrl;
    };

    const handleAddToDocument = () => {
        if (editedImage) {
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');
            if (!ctx) return;

            const image = new Image();
            image.src = editedImage;

            image.onload = () => {
                canvas.width = image.width;
                canvas.height = image.height;
                ctx.drawImage(image, 0, 0);

                canvas.toBlob((blob) => {
                    if (blob) {
                        const payload = { file: new File([blob], 'edited-image.png', { type: blob.type }) };

                        dispatch(uploadImage(payload))
                            .unwrap()
                            .then( async (response) => {

                                await  dispatch(updateProject({ ...currentProject, image: response }));
                                setModalOpen(false);

                            })
                            .catch((error) => console.error('Failed to upload image:', error));
                    }
                }, 'image/png');
            };
        }
    };

    const backFunction=()=>{
        setEditMode('')
        //cleanFilter()
    }
    const handleCrop = () => {
        if (croppedAreaPixels && editedImage) {
             const image = new Image();
            image.crossOrigin = "anonymous";
            console.log(editedImage)
             image.src = editedImage;

            image.onload = () => {
                const canvas = document.createElement('canvas');
                canvas.width = croppedAreaPixels.width;
                canvas.height = croppedAreaPixels.height;
                const ctx = canvas.getContext('2d');
                if (!ctx) return;

                ctx.drawImage(
                    image,
                    croppedAreaPixels.x,
                    croppedAreaPixels.y,
                    croppedAreaPixels.width,
                    croppedAreaPixels.height,
                    0,
                    0,
                    croppedAreaPixels.width,
                    croppedAreaPixels.height
                );


                const croppedImage = canvas.toDataURL('image/png');
                setEditedImage(croppedImage);
                setEditMode('');
            };

            image.onerror = () => {
                console.error("Failed to load the image. Check CORS policy.");
            };
        }
    };
    const saveImageWithFilter = () => {
        if (!editedImage) return;

        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        if (!ctx) {
            console.error("2D контекст не поддерживается.");
            return;
        }

        const image = new Image();
        image.crossOrigin = "anonymous";
        image.src = editedImage;

        image.onload = () => {

            canvas.width = image.width;
            canvas.height = image.height;

            switch (activeFilter) {
                case "grayscale":
                    ctx.filter = "grayscale(100%)";
                    break;
                case "vintage":
                    ctx.filter = "sepia(70%) brightness(0.9)";
                    break;
                case "warm":
                    ctx.filter = "contrast(120%) brightness(110%) hue-rotate(-15deg)";
                    break;
                case "cool":
                    ctx.filter = "contrast(120%) brightness(90%) hue-rotate(180deg)";
                    break;
                case "retro":
                    ctx.filter = "saturate(150%) contrast(85%)";
                    break;
                case "dreamy":
                    ctx.filter = "blur(2px) brightness(120%)";
                    break;
                default:
                    ctx.filter = "none";
            }

            ctx.drawImage(image, 0, 0, image.width, image.height);

            const filteredImage = canvas.toDataURL("image/png");

            setEditedImage(filteredImage);
            setEditMode('');
        };

        image.onerror = () => {
            console.error("Ошибка загрузки изображения. Проверьте CORS.");
        };
    };

    return (
        <div className={s.container}>
            {imageUrl &&!isModalOpen? (

                <div className={s.image_wrapper} onClick={() => setModalOpen(true)}>

                    <img src={imageUrl} alt="Uploaded" className={s.image} />
                </div>
            ) : (
                <div
                    onClick={() => setModalOpen(true)}
                    className={`${s.image_container}`}
                >
                    <img src={add_photo} alt="Add" />
                </div>
            )}

            {isModalOpen && (
                <Modal isOpen={isModalOpen} onClose={handleModalClose}
                       header={'Edit Image'}
                       isArrowBack={editMode!=''}
                       backFunction={backFunction}>
                    {editedImage ? (

                        <div className={s.modal}>
                            {editMode === '' && (
                                <div className={s.modal_image_wrapper}>
                                    <img
                                        src={editedImage}
                                        alt="Preview"
                                        className={s.modal_image}
                                    />
                                </div>
                            )}
                            {editMode === 'effect' && (
                                <div
                                    className={`${s.modal_image_wrapper} ${activeFilter ? s[`filter-${activeFilter}`] : ''}`}>
                                    <img src={editedImage} alt="Preview"  className={s.modal_image}/>
                                </div>
                            )}
                            {editMode === 'size' && (

                                <CropImage image={editedImage} setCroppedAreaPixels={setCroppedAreaPixels}/>

                            )}
                            {editMode === '' &&
                                <div className={s.customize_container}>
                                    <p>Customize</p>
                                    <div className={s.edit_modes}>
                                        <button
                                            onClick={() => setEditMode('effect')}
                                        >
                                            <img src={effect} className={s.custom_icon}/> Effects
                                        </button>
                                        <button
                                            onClick={() => setEditMode('size')}
                                        >
                                            <img src={size} className={s.custom_icon}/>Resize
                                        </button>

                                    </div>
                                </div>

                            }

                            {editMode === 'size' && <div  className={s.flex}>
                                <Button text="Crop and Save" onClick={handleCrop}/>
                                <Button text="Cancel" type="secondary" onClick={() => setEditMode('')}/>
                            </div>}
                            {editMode === 'effect' && (
                                <div className={s.effects_list}>
                                    {filterOptions.map(({ name, filter }) => (
                                        <button
                                            key={filter}
                                            className={`${s.effect} ${activeFilter === filter ? s.active : ''}`}
                                            onClick={() => applyFilter(filter)}
                                        >
                                            {name}
                                        </button>
                                    ))}
                                </div>

                            )}
                            {editMode === 'effect' && (
                                <div className={s.flex}>

                                    <Button text="Save Filter" onClick={saveImageWithFilter}/>
                                    <Button text="Cancel" type={'secondary'}
                                            onClick={() => setEditMode('')}/>
                                </div>
                            )}

                            {editMode === '' &&
                                <div className={s.modal_buttons}>

                                    {editedImage !== imageUrl && (
                                        <Button text="Save and add to post" onClick={handleAddToDocument} />
                                    )}
                                    <Button text="Retry" type={'secondary'} onClick={handleRetry}/>
                                </div>}


                        </div>
                    ) : (

                        <div className={s.modal}>
                            <div className={s.file_upload_container}>
                                <FileUpload uploadDocument={(payload) => handleImageUpload(payload.file)}/>
                            </div>
                            <span>or</span>
                            <GenerateImage projectId={currentProject?.id}/>
                        </div>
                    )}
                </Modal>
            )}
        </div>
    );
};

export default ImageUpload;


